/**
 * Fact Finder Configuration
 *
 * Controls which features are enabled in the Fact Finder form.
 * Set advancedMode to false to collect only basic information:
 * - Personal details: Title, First name, Middle name, Last name, Gender, Date of birth
 * - Contact details: Preferred contact method, Home phone, Mobile phone, Work phone, Email, Country of residence
 */

export interface FactFinderConfig {
  /**
   * When true, collects full financial information (employment, assets, liabilities, income, expenses, requirements).
   * When false, collects only basic personal and contact details.
   */
  advancedMode: boolean;
}

/**
 * Default configuration - set to false to use basic mode
 * TODO: This can be moved to environment variables or admin settings in the future
 */
export const factFinderConfig: FactFinderConfig = {
  advancedMode: false, // Set to true to enable all sections
};

/**
 * Sections shown in basic mode (advancedMode: false)
 */
export const BASIC_MODE_SECTIONS = ["applicants", "next-steps", "consent"] as const;

/**
 * All sections shown in advanced mode (advancedMode: true)
 */
export const ADVANCED_MODE_SECTIONS = [
  "applicants",
  "employment",
  "assets",
  "liabilities",
  "income",
  "expenses",
  "requirements",
  "consent",
] as const;

/**
 * Get the sections to display based on the current mode
 */
export function getActiveSections(config: FactFinderConfig) {
  return config.advancedMode ? ADVANCED_MODE_SECTIONS : BASIC_MODE_SECTIONS;
}
